import Vue from 'vue'
import VueRouter from 'vue-router'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import NotFound from '@/views/404'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'RealNameAssistant-Introduce',
    meta: { pageTitle: '鱼宿' },
    component: () => import(/* webpackChunkName: 'real-name-assistant' */ '@/views/real-name-assistant/introduce')
  },
  {
    path: '/real-name-assistant/direction',
    name: 'RealNameAssistant-Direction',
    meta: { pageTitle: '鱼宿 - 操作指南' },
    component: () => import(/* webpackChunkName: 'real-name-assistant' */ '@/views/real-name-assistant/direction')
  },
  {
    path: '/real-name-assistant/protocol/privacy',
    name: 'RealNameAssistant-Direction',
    meta: { pageTitle: '鱼宿 - 隐私协议' },
    component: () => import(/* webpackChunkName: 'real-name-assistant' */ '@/views/real-name-assistant/protocol/privacy')
  },
  {
    path: '/real-name-assistant/protocol/service',
    name: 'RealNameAssistant-Direction',
    meta: { pageTitle: '鱼宿 - 用户协议' },
    component: () => import(/* webpackChunkName: 'real-name-assistant' */ '@/views/real-name-assistant/protocol/service')
  },
  {
    path: '/real-name-assistant/protocol/usingHelp',
    name: 'RealNameAssistant-Direction',
    meta: { pageTitle: '鱼宿 - 使用手册' },
    component: () => import(/* webpackChunkName: 'real-name-assistant' */ '@/views/real-name-assistant/protocol/usingHelp')
  },
  {
    path: '/404',
    name: '404',
    meta: { pageTitle: '404' },
    component: NotFound
  },
  {
    path: '/*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    let result = { x: 0, y: 0 }
    if (to.hash) {
      result = { selector: decodeURI(to.hash) }
    } else if (savedPosition) {
      result = savedPosition
    }
    return result
  }
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.meta.pageTitle) {
    document.title = to.meta.pageTitle
  }
  next()
})

router.afterEach((to, from) => {
  // setTimeout(() => {
  //   const anchor = document.getElementById(decodeURI(to.hash.substr(1)))
  //   if (anchor) {
  //     document.documentElement.scrollTop = anchor.offsetTop
  //   } else {
  //     document.documentElement.scrollTop = 0
  //   }
  // }, 0)
  NProgress.done()
})

export default router
